import styled from '@emotion/styled'

export const InfosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  column-gap: 10px;
  row-gap: 30px;
  padding-bottom: 70px;
  @media (max-width: 768px) {
    grid-template-columns: repeat(1, 1fr);
  }
`

export const StyleProfileInfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  align-items: flex-start;
  color: ${(props: any) => props.theme.colors.text};
`

export const StyleLabel = styled.p`
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 20px;
`
export const StyleTextContaienr = styled.div`
  padding: 0px 12px;
  display: flex;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.25px;
  border-radius: 6px;
  height: 50px;
  border: 1px solid ${(props: any) => props.theme.colors.borderColor};
  width: 90%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`
